export class ListAIAgentSessions400Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAIAgentSessions400Response.attributeTypeMap;
    }
    constructor() {
    }
}
